import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";

import { Row, Col, Button } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAmusementPlace from "../../../core/api/api.amusementPlace";
import _ from "lodash";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import ApiAmusementService from "../../../core/api/api.amusementService";
import SwalMessage from "../_Components/SwalMessage";
import ApiRegion from "../../../core/api/api.region";

export const CreateEditAmusementPlace = () => {
  let { id } = useParams();
  const [place, setPlace] = useState({});
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const [selectPlaceCityList, setselectPlaceCityList] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    getValues,
    setValue,
    setFocus,
  } = useForm({ defaultValues: { id: 0 } });

  useEffect(() => {
    (async () => {
      try {
        const responsegetAllCity = await ApiRegion.getAllCity();
        setAllAmusementCityList(responsegetAllCity);
        if (id != undefined) {
          const response = await ApiAmusementPlace.get(id);
          setValue("id", response.data.id);
          setValue("placeName", response?.data.name);
          setValue("nameEn", response?.data.nameEn);
          setValue(
            "placeCityListId",
            response?.data?.cityList.map((item) => ({
              value: item.id,
              label: item.id + "-" + item.name,
            })),
          );
          setValue("address", response?.data.address);
          setValue("description", response?.data.description);
          setValue("email", response?.data.email);
          setValue("lat", response?.data.lat);
          setValue("lon", response?.data.lon);
          setValue("phoneNumber", response?.data.phoneNumber);
          setValue("status", response?.data.status);
          setValue("webSite", response?.data.webSite);
          setValue("workTime", response?.data.workTime);
          setValue("imageUrl", response?.data.imageUrl);
        } else {
        }
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => { };
  }, []);

  function handleChangeMultiCity(valueItem, option) {
    //setselectPlaceCityList(valueItem)
    setValue("placeCityListId", valueItem);
    //  if (option?.action=="select-option")
    // {
    //  setselectPlaceCityList([...selectPlaceCityList,option.option])

    //  }else   if (option?.action=="remove-value"){
    //     // setselectPlaceCityList(selectPlaceCityList.filter(item => item !== option.removedValue));
    //     setselectPlaceCityList(valueItem);
    //  }
  }

  const changeField = (field, event) => {
    if (event.target.type == "checkbox") {
      setPlace({ ...place, [field]: event.target.checked });
    } else setPlace({ ...place, [field]: event.target.value });
  };

  const onSubmit = async (data) => {
    try {
      data.name = data.placeName;
      data.placeCityListId = data.placeCityListId?.map((item) => item.value);
      let response = null;
      if (data.id > 0) {
        response = await ApiAmusementPlace.update(id, data);
      } else {
        response = await ApiAmusementPlace.create(data);
      }

      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
      console.log("error=", error);
    }
  };

  const defaultValidator = {
    name: false,
  };
  function hasErrorValidation() {
    const validatorClone = _.cloneDeep(defaultValidator);

    if (place.name === undefined || place.name === "") {
      validatorClone.name = true;
      return true;
    }
    return false;
  }

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">ایجاد مکان جدید</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              برای افزودن مکان جدید، فرم زیر را تکمیل نمایید
            </span>
          </h3>
        </div>

        {/*Start body */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card-body pt-3 pb-0 border-top">
            <form noValidate autoComplete="off" className="mt-3">
              <Row>
                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="placeName"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام مکان"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                  {errors.placeName && <small className="text-danger">لطفا نام مکان را وارد نمایید !</small>}
                </Col>
                <Col xs="12" sm="7" lg="7" className="mb-5">
                  <Controller
                    name="nameEn"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام انگلیسی"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>

                <Col xs="12" sm="7" lg="7" className="mb-3">
                  <Controller
                    name="placeCityListId"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        placeholder="نام شهر"
                        options={allAmusementCityList?.map((item) => ({
                          value: item.id,
                          label: item.id + "-" + item.name,
                        }))}
                        TextFieldProps={{
                          label: "Countries",
                          InputLabelProps: {
                            htmlFor: "react-select-multiple",
                            shrink: true,
                          },
                        }}
                        value={value}
                        onChange={handleChangeMultiCity}
                        // menuIsOpen={true}
                        closeMenuOnSelect={false}
                        isMulti
                      />
                    )}
                  />
                  {errors.placeCityListId && (
                    <small className="text-danger">لطفا حداقل یک شهر را انتخاب نمایید !</small>
                  )}
                </Col>

                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="تلفن"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="address"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="آدرس"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        multiline
                        rowsMax="8"
                        value={value || ""}
                        onChange={onChange}
                        sx={{
                          ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                            padding: "8.5px 14px 8.5px 0px !important",
                          }
                        }}
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="lat"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="lat"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="lon"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Lon"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="webSite"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="وب سایت"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="email"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="ایمیل"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="description"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="بررسی اجمالی"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        multiline
                        rowsMax="10"
                        value={value || ""}
                        onChange={onChange}
                        sx={{
                          ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                            padding: "8.5px 14px 8.5px 0px !important",
                          }
                        }}
                      />
                    )}
                  />
                </Col>
                {/* <Col xs='12' sm='7'  lg='7'>
                                <TextField
                                    select
                                    label="نوع"
                                    className="w-100 mt-4"
                                    variant="outlined"
                                    size='small'>
                                    <MenuItem key='1' value='1'>تفریحات</MenuItem>
                                    <MenuItem key='1' value='1'>اماکن دیدنی</MenuItem>
                                    </TextField>
                            </Col>
                            <Col xs='12' sm='7'  lg='7'>
                                <TextField
                                    select
                                    label="نوع مکان"
                                    className="w-100 mt-4"
                                    variant="outlined"
                                    size='small'>
                                    <MenuItem key='1' value='1'>root</MenuItem>
                                    <MenuItem key='1' value='1'>title</MenuItem>
                                    <MenuItem key='1' value='1'>child</MenuItem>
                                    </TextField>
                            </Col>
                            <Col xs='12' sm='7'  lg='7'>
                                <TextField
                                    label="آدرس عکس"
                                    className="w-100 mt-4"
                                    variant="outlined"
                                    size='small'/>
                            </Col> */}
                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="imageUrl"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="عکس شاخص "
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="7" lg="7">
                  <Controller
                    name="workTime"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="ساعت کاری"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
                {/* <Col xs='12' sm='7' lg='7'>
                                <TextField
                                    label="MetaKeywords"
                                    margin="normal"
                                    variant="outlined"
                                    size='small'
                                    value={place?.metaKeywords || ''}
                                     onChange={(e) => changeField("metaKeywords", e)}
                                />
                            </Col>
                            <Col xs='12' sm='7' lg='7'>
                                <TextField
                                    label="MetaDescription"
                                    margin="normal"
                                    variant="outlined"
                                    size='small'
                                    value={place?.metaDescription || ''}
                                     onChange={(e) => changeField("metaDescription", e)}
                                />
                            </Col> */}

                <Col xs="12">
                  <Controller
                    name="status"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <FormControlLabel
                        control={<Checkbox color="primary" checked={value || false} onChange={onChange} />}
                        label="فعال"
                      />
                    )}
                  />
                </Col>
              </Row>
            </form>
          </div>
          <div className="card-footer">
            <Button variant="success" type="submit">
              <SaveIcon /> ذخیره
            </Button>

            <Link to="/amusementPlace" className="btn btn-danger ml-3">
              <CloseIcon /> بازگشت{" "}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};
